<template>
  <div class="business-workflows-tab" :key="z">
    <WorkflowCreateNew :key="workflowNewKey" />
    <WorkflowEdit />
    <WorkflowEditJSON />
    <WorkflowJSONEditNew
      v-if="editJSON"
      :workflow="selectedWorkflow"
      @close="editJSON = false"
    />
    <ManageRolesModal />
    <WorkflowStatsModal />
    <WorkflowAddRoleModal />

    <div v-if="!workflows" class="card">
      <div class="card-content has-text-info">No Workflows</div>
    </div>
    <div
      v-for="w in workflows"
      :key="w.id"
      class="section"
      :class="{ 'bg-pink': w.state !== 'active' || w.is_deleted }"
    >
      <!-- <div class="card-content"> -->
      <div class="content has-text-left">
        <p class="field-name">
          <span class="has-text-weight-medium has-text-black">
            {{ w.workflow_type_name }}
            <span v-if="w.is_deleted" class="has-text-danger">DELETED</span>
          </span>

          <span class="is-pulled-right">
            <span class="link" @click="copyID(w.id)">{{
              shortenString(w.id, 5)
            }}</span>
            {{ timeAgo(w.updated_at) }}
          </span>
        </p>
        <!-- <i class="fa fa-signature" style="margin-right: 8px" /> -->
        <a @click="viewWorkflow(w)" class="has-text-weight-medium">
          {{ w.name }}
        </a>
        <span v-if="w.workflow_type_name === 'Delivery'">
          <span v-if="w.data.surge" class="surge" @click="clearSurge(w)">
            <i class="fa fa-cloud-showers-heavy" /> +{{ w.data.surge }}฿
          </span>
          <span v-else class="surge-off" @click="setSurge(w, 15)">
            <i class="fa fa-umbrella" /> Surge?
          </span>
        </span>
        <span class="is-pulled-right">
          <img
            v-if="isFleet(w)"
            :src="vehicleImg(w)"
            class="icon"
            @click="vehicleImgInfo(w)"
          />
          <i class="fa fa-home" @click="gotoWorkflowHome(w)" />
          <i class="fa fa-tools fa-sm" @click="toggleOptions(w)" />
          <i class="fa fa-align-justify" @click="editWorkflow(w)" />
          <i
            class="fa fa-pencil-alt has-text-info"
            @click="editWorkflowJSON(w)"
          />
        </span>

        <hr />
        <span style="margin-top: -2px" class="is-pulled-right">
          <toggle-button
            :value="w.state === 'active'"
            :color="{ checked: '#00D1B2', unchecked: '#FF3860' }"
            :sync="true"
            :height="36"
            :width="60"
            @change="toggleWorkflow(w, $event.value)"
          />
          <!-- :labels="{ checked: 'ON', unchecked: 'OFF' }" -->
        </span>
        <div class="buttons">
          <!-- <button class="button is-white is-rounded" @click="manageRoles(w)">
            <i class="fa fa-plus" />&nbsp;Add
          </button> -->
          <button class="button is-white is-rounded" @click="viewRoles(w)">
            <i class="far fa-user fa-sm" />&nbsp;Roles
          </button>
          <button class="button is-white is-rounded" @click="openStats(w)">
            <i class="fa fa-list" />&nbsp;Orders
          </button>
        </div>
      </div>
      <!-- </div> -->
      <div v-if="w.showOptions" class="options-wrapper buttons">
        <span class="button is-small" @click="setGeometry(w)">Geometry</span>
      </div>
    </div>

    <div class="card-content" style="margin-bottom: 16px">
      <span class="button is-rounded" @click="addWorkflow">
        <i class="fa fa-plus fa-sm" />&nbsp;Add Workflow
      </span>
    </div>

    <ManageRolesPanel
      v-if="manageRolesWorkflow"
      :w="manageRolesWorkflow"
      @close="manageRolesWorkflow = null"
      @addRole="addRole"
    />
  </div>
</template>

<script>
import EventBus from "../eventBus.js";
import vehicles from "@/vehicles";

import WorkflowCreateNew from "@/components/WorkflowCreateNew.vue";
import WorkflowEdit from "@/components/WorkflowEdit.vue";
import WorkflowEditJSON from "@/components/WorkflowEditJSON.vue";
import WorkflowJSONEditNew from "@/components/WorkflowJSONEditNew.vue";
import ManageRolesModal from "@/components/ManageRolesModal.vue";
import WorkflowStatsModal from "@/components/WorkflowStatsModal.vue";
import WorkflowAddRoleModal from "@/components/WorkflowAddRoleModal.vue";
import ManageRolesPanel from "@/components/ManageRolesPanel.vue";

export default {
  name: "BusinessWorkflowsTab",
  components: {
    WorkflowCreateNew,
    WorkflowEdit,
    WorkflowEditJSON,
    WorkflowJSONEditNew,
    ManageRolesModal,
    WorkflowStatsModal,
    WorkflowAddRoleModal,
    ManageRolesPanel,
  },
  data() {
    return {
      manageRolesWorkflow: null,
      editJSON: false,
      selectedWorkflow: null,
      roles: {
        // currently only supports worker roles, format -- workflow: [role_names]
        Fleet: ["Driver", "Dispatcher", "Fleet Manager"],
        Accounting: ["Accountant"],
        Logistics: ["Logistics Agent"],
        Commerce: ["Commerce Agent", "Commerce Manager"],
        Delivery: [
          "Delivery Driver",
          "Delivery Dispatcher",
          "Delivery Manager",
        ],
        Agent: ["Agent"],
        // legacy
        Songthaew: ["Driver", "Dispatcher"],
        Motocy: ["Driver", "Dispatcher"],
        Taxi: ["Driver", "Dispatcher"],
        "Public Tuk Tuk": ["Driver", "Dispatcher"],
        "Private Tuk Tuk": ["Driver", "Dispatcher"],
        "Sii Lor": ["Driver", "Dispatcher"],
      },
      workflowNewKey: 0, // for re-rendering WorkflowCreateNew modal
      z: 0,
    };
  },
  computed: {
    workflows() {
      return this.$store.getters.getSelectedBusinessWorkflows;
    },
  },
  mounted() {},
  methods: {
    copyID(id) {
      this.$copyText(id);
      this.infoToast("Copied Workflow ID<br>" + id);
    },
    gotoWorkflowHome(w) {
      if (w.workflow_type_name === "Commerce") {
        this.goto(`commerce_home/${w.business_id}`);
      } else {
        this.goHome();
      }
    },
    clearSurge(w) {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='margin-bottom:12px; font-size:1.2em'>Surge Delivery Bonus</p>
        <p>Click to remove surge.</p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Remove Surge",
      }).then((val) => {
        if (val.value) {
          this.setSurge(w, 0);
        }
      });
    },
    setSurge(w, surge) {
      var loader = this.loadingDots("orange");
      w.data.surge = surge;
      this.$store
        .dispatch("updateWorkflow", {
          id: w.id,
          // business_id: this.w.business_id,
          // name: this.w.name,
          data: w.data,
        })
        .then(() => {
          this.$store
            .dispatch("getWorkflows", w.business_id)
            .then(() => this.successToast("JSON Saved!", "top"))
            .catch((err) => this.apiError(err));
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    isFleet(w) {
      var fleetWorkflows = [
        "Fleet",
        "Sii Lor",
        "Public Tuk Tuk",
        "Private Tuk Tuk",
        "Songthaew",
        "Taxi",
        "Motocy",
      ];
      return fleetWorkflows.includes(w.workflow_type_name);
    },
    vehicleImg(w) {
      var iconName = w.data.icon || w.name;
      return vehicles.img(iconName);
    },
    vehicleImgInfo(w) {
      var iconName = w.data.icon || w.name;
      var msg = `Icon name: ${iconName}`;
      if (!w.data.icon) msg += " (default)";
      this.infoToast(msg);

      return vehicles.img(iconName);
    },
    setGeometry(w) {
      this.goto(`/geometry?workflow_id=${w.id}&type=pickup_area_polygon`);
    },
    toggleOptions(w) {
      // if (w.showOptions) w.showOptions = false;
      // else w.showOptions = true;
      w.showOptions = !w.showOptions;
      this.z += 1;
    },
    toggleWorkflow(w, val) {
      this.console("switchChange", val, w);
      if (val) {
        this.$swal({
          title: "Turn on workflow?",
          html: `<i class="fa fa-thumbs-up fa-4x" style="color:palegreen" />`,
          showCancelButton: true,
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("no"),
        }).then((result) => {
          if (result.value) {
            w.state = "active";
            this.changeWorkflowState(w);
          }
        });
      } else {
        this.$swal({
          title: "Turn off workflow?",
          html: `<i class="fa fa-moon fa-4x" style="color:lightblue" />`,
          showCancelButton: true,
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("no"),
        }).then((result) => {
          if (result.value) {
            w.state = "inactive";
            this.changeWorkflowState(w);
          }
        });
      }
    },
    changeWorkflowState(w) {
      var loader = this.loadingDots("orange");
      this.$store
        .dispatch("setWorkflowState", { id: w.id, state: w.state })
        .then((res) => this.console("changeWorkflowState success", res.data))
        .catch((err) => {
          this.apiError(err);
          if (w.state === "active") w.state = "inactive";
          else w.state = "active"; // on error change it back
        })
        .finally(() => loader.hide());
    },
    addWorkflow() {
      this.console("add workflow");
      if (this.loginOkay()) {
        // should be logged in and permissioned...
        this.workflowNewKey += 1; // refresh the modal and wait for nextTick
        this.$nextTick(() => {
          this.displayModal(".workflow-create-new-modal");
        });
      }
    },
    editWorkflow(w) {
      // original transport workflow edit flow
      var arr = ["Delivery", "Commerce", "Logistics", "Fleet", "Accounting"];
      if (arr.includes(w.workflow_type_name)) {
        this.editJSON = true;
        this.selectedWorkflow = w;
        // EventBus.$emit("EDIT_WORKFLOW_JSON", w); // free-form edit JSON
        // this.displayModal(".workflow-edit-json-modal");
      } else {
        EventBus.$emit("EDIT_WORKFLOW", w);
        this.displayModal(".workflow-edit-modal");
      }
    },
    editWorkflowJSON(w) {
      this.editJSON = true;
      this.selectedWorkflow = w;
      // EventBus.$emit("EDIT_WORKFLOW_JSON", w); // free-form edit JSON
      // this.displayModal(".workflow-edit-json-modal");
    },
    viewWorkflow(w) {
      var YAML = require("json2yaml");
      var ymlText = YAML.stringify(w.data);
      this.$swal({
        html: `<div style="text-align:left; white-space:pre-line; font-size:0.8em">${ymlText}</div>`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    openStats(w) {
      this.displayModal(".workflow-stats-modal");
      EventBus.$emit("WORKFLOW_STATS", w.id);
    },
    viewRoles(w) {
      this.manageRolesWorkflow = w;
      // this.displayModal(".manage-roles-modal");
      // EventBus.$emit("MANAGE_ROLES", w);
    },
    parsePhoneNumber(raw) {
      if (raw[0] === "0") {
        return `+66${raw.substring(1, raw.length)}`; // probably local thai number like 0909588716
      }
      if (raw.substring(0, 4) === "+660") {
        return `+66${raw.substring(4, raw.length)}`; // thai number with extra 0
      }
      if (raw[0] === "+") {
        return raw; // could be correct international number
      }
      return null;
    },
    addRole() {
      var w = this.manageRolesWorkflow;
      var data = { workflow: w, roles: this.roles[w.workflow_type_name] };
      EventBus.$emit("WORKFLOW_ADD_ROLE", data);
      this.displayModal(".workflow-add-role-modal");
      this.$nextTick(() => (this.manageRolesWorkflow = null));
    },
    manageRoles(w) {
      var data = { workflow: w, roles: this.roles[w.workflow_type_name] };
      EventBus.$emit("WORKFLOW_ADD_ROLE", data);
      this.displayModal(".workflow-add-role-modal");

      // // otherRoles are non-driver related roles
      // var otherRoles = [
      //   "Admin",
      //   "Agent",
      //   "Delivery",
      //   "Commerce",
      //   "Logistics",
      //   "Accounting"
      // ];
      // if (otherRoles.includes(w.name)) return this.addOtherRole(w);
      // this.$swal({
      //   title: this.$t("business.add-driver-by-mobile"), //"Add driver by mobile",
      //   input: "text", //"number",
      //   inputValue: "+66",
      //   showCancelButton: false,
      //   inputValidator: val => {
      //     if (!val || val.length < 10) return "You must enter a mobile number!";
      //     if (!this.parsePhoneNumber(val)) return "Invalid phone number!";
      //   }
      // }).then(val => {
      //   console.log("manageRoles", val);
      //   if (val.value) {
      //     var n = this.parsePhoneNumber(val.value); // parse number
      //     if (n.charAt(n.length - 1) === "d") {
      //       var phoneNumber = n.slice(0, n.length - 1); // clean if dispatcher
      //       return this.createWorkerRole(w, phoneNumber, "Dispatcher");
      //     }
      //     if (n.charAt(n.length - 1) === "f") {
      //       phoneNumber = n.slice(0, n.length - 1); // clean if dispatcher
      //       return this.createCustomerRole(w, phoneNumber, "Free");
      //     }
      //     console.log("createWorkerRole", n);
      //     return this.createWorkerRole(w, n, "Driver");
      //   }
      // });
    },
    // should combine into func createRole(w, phoneNumber, roleType, roleName)
    createWorkerRole(w, phoneNumber, roleName) {
      this.$store
        .dispatch("createRole", {
          phone_number: phoneNumber,
          business_id: w.business_id,
          workflow_id: w.id,
          workflow_name: w.name,
          role_type: "worker",
          role_name: roleName, //"Driver"
        })
        .then(() => this.success())
        .catch((err) => this.apiError(err));
    },
    createCustomerRole(w, phoneNumber, roleName) {
      this.$store
        .dispatch("createRole", {
          phone_number: phoneNumber,
          business_id: w.business_id,
          workflow_id: w.id,
          workflow_name: w.name,
          role_type: "customer",
          role_name: roleName, // "Free"
        })
        .then(() => this.success())
        .catch((err) => this.apiError(err));
    },
    addOtherRole(w) {
      var roleName = "Superuser";
      if (w.name === "Agent") roleName = "Agent";
      if (w.name === "Delivery") roleName = "Delivery Driver"; // "Delivery Dispatcher";
      if (w.name === "Commerce") roleName = "Commerce Agent";
      if (w.name === "Logistics") roleName = "Logistics Agent";
      if (w.name === "Accounting") roleName = "Accountant";
      this.$swal({
        title: roleName,
        text: "Add role by mobile",
        input: "text", //"number",
        inputValue: "+66",
        showCancelButton: false,
        inputValidator: (val) => {
          if (!val || val.length < 10) return "You must enter a mobile number!";
          var loader = this.loadingDots("blue");
          this.$store
            .dispatch("createRole", {
              phone_number: val,
              business_id: w.business_id,
              workflow_id: w.id,
              workflow_name: w.name,
              role_type: "worker",
              role_name: roleName,
            })
            .then(() => this.success())
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        },
      });
    },
  },
};
</script>

<style scoped>
hr {
  margin: 10px 0;
}
.field-name {
  margin-bottom: 0;
  line-height: 0pt;
  font-size: 0.8em;
  opacity: 0.6;
}
.card {
  margin-top: 10px;
}
.card-content {
  padding: 16px 12px;
  padding-bottom: 12px;
}
.fa-tools {
  margin-right: 20px;
  /* color: navy; */
}
.fa-align-justify {
  margin-right: 20px;
  /* color: brown; */
}
.fa-home {
  margin-right: 20px;
}
/* .fa-pencil-alt {
  margin-right: 20px;
} */
.options-wrapper {
  background-color: #123;
  padding: 10px;
}
.icon {
  margin-left: -55px;
  margin-top: -6px;
  position: absolute;
  height: 30px;
  width: auto;
}
.buttons .button {
  padding: 9px;
}
.bg-pink {
  background-color: rgba(255, 192, 203, 0.5) !important;
}
.surge {
  /* background-color: #444; */
  background-color: var(--danger);
  color: white;
  padding: 2px 8px;
  border-radius: 25px;
  font-size: 0.9em;
  font-weight: 500;
}
.surge-off {
  background-color: #ddd;
  padding: 2px 8px;
  border-radius: 25px;
  font-size: 0.9em;
}
.section {
  text-align: left;
  background-color: white;
  padding: 16px 12px;
  margin-top: 10px;
}
</style>